import { FormInputState, FormModel, ResultValue } from 'src_common/common/mobx-utils/Form';
import { computed, makeAutoObservable } from 'mobx';
import { InputStatus } from 'src/components/Input/InputStatus';

export class FieldState {
    public readonly fieldModel: FormModel<string>;
    public readonly field: FormInputState<string>;
    public readonly fieldStatus: InputStatus;

    constructor() {
        this.field = new FormInputState('', false);
        this.fieldModel = this.field.toModel();
        this.fieldStatus = new InputStatus(this.fieldModel);
        makeAutoObservable(this);
    }

    @computed public get value(): string {
        const result = this.fieldModel.result;
        if (result instanceof ResultValue) {
            return result.value;
        }
        return '';
    }
}
